<script setup lang="ts">
import { showQueueView } from '@collector/desktop-feature-incidents-queue-ui'
import { Button } from '@collector/shared-ui'

interface Props {
  hasQueueError: boolean
}

defineProps<Props>()
</script>

<template>
  <Button
    class="bg-error-10 border-error-10 text-error-6 hover:bg-error-9 hover:border-error-9 font-bold"
    :class="{
      invisible: !hasQueueError,
    }"
    size="xs"
    width="slim"
    @click="showQueueView"
  >
    <slot />
  </Button>
</template>
